



















































































































import mixins from 'vue-typed-mixins'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import MediaPreview from '@/components/MediaPreview.vue'
import TimelineMixin from '../mixins/TimelineMixin'
import UserActionMixin from '@/mixins/UserActionMixin'
import { loadmetadataVideo, generateUUID, isObject } from '@/utils/helpers'
import { TimelineItem } from '../store/modules/Timeline'

export default mixins(TimelineMixin, UserActionMixin).extend({
  name: 'TimelinePost',
  components: { MediaPreview },
  data() {
    return {
      body: '',
      imageFiles: [],
      videoFiles: [],
      file: null,
      selectedFileUrl: '',
      selectedFileType: '',
      isActivePreview: false,
      isPremier: false,
      isLoading: false,
      isSubmitting: false,
      progressValue: 0
    }
  },
  computed: {
    ...mapGetters('Timeline', ['postPoint']),
    ...mapGetters('MyData', ['myGender', 'isMan', 'isWoman']),

    isPhotoFileType(): boolean {
      return this.selectedFileType === 'photo'
    },
    isVideoFileType(): boolean {
      return this.selectedFileType === 'video'
    },
    isMessageMaxLengthOver(): boolean {
      return this.body.length > this.BODY_MAX_LENGTH
    },
    BODY_MAX_LENGTH(): number {
      return 500
    },
    isVisibleProgress(): boolean {
      return this.isSubmitting && this.progressValue > 0
    },
    progressMax(): number {
      return 100
    },
    PICTURESOURCETYPE_PHOTOLIBRARY(): number {
      return Camera.PictureSourceType.PHOTOLIBRARY
    },
    PICTURESOURCETYPE_CAMERA(): number {
      return Camera.PictureSourceType.CAMERA
    },
    isRejected(): boolean {
      return this.$route.params.rejected === '1'
    },
    rejectedEntry(): TimelineItem {
      return this.$store.getters['Timeline/rejectedEntry']
    },
    reuseFlag(): string {
      if (!this.rejectedEntry) return ''
      return this.selectedFileUrl === this.rejectedEntry.media_url ? '1' : '0'
    },
    rejectedText(): string {
      return this.$store.getters['Timeline/rejectedText']
    },
    postWarnings(): string[] {
      return [
        ...(this.isMan
          ? ['投稿は1日1件まで無料', `2件目からは1件につき${this.postPoint}pt消費`]
          : []),
        'アダルトな内容は投稿しても公開されません',
        '特定の人物へのメッセージ代わりとしては利用できません',
        '他SNSのID等は投稿しても掲載されません',
        '投稿は事務局が確認後に公開されます'
      ]
    },
    premierWarning(): string[] {
      return [
        '有料にすると男性がファイルを購入するたびに30pt獲得できます。',
        '風景・ペット・食べ物だけの写真や動画は有料投稿には掲載されません。必ずご自身の顔や体の一部が映るように撮影してください。'
      ]
    }
  },
  watch: {
    isActivePreview(val: boolean) {
      if (!val && this.selectedFileUrl) {
        URL.revokeObjectURL(this.selectedFileUrl)
        this.selectedFileUrl = null
        this.file = null
      }
    }
  },
  created() {
    if (this.isRejected && !this.rejectedEntry) {
      // リジェクト投稿編集中にリロードしたら必要なデータがクリアされ
      // 編集できなくなるので自分の投稿にリダイレクト
      this.$store.commit('Timeline/setType', 3)
      this.$router.replace('/timeline')
    }
  },
  mounted() {
    if (this.isRejected && this.rejectedEntry) {
      this.body = this.rejectedEntry.comment
      this.isPremier = this.rejectedEntry.is_premier
      if (this.rejectedEntry.media_url) {
        this.selectedFileUrl = this.rejectedEntry.media_url
        this.selectedFileType = this.rejectedEntry.media_type
        this.isActivePreview = true
      }
    }
  },
  methods: {
    ...mapMutations('Timeline', ['setType']),
    ...mapActions('Timeline', ['post']),

    /**
     * Native の画像を取得
     */
    async getPictureWithNative(sourceType: number) {
      if (!this.$_hasCordova) {
        return
      }
      this.selectedFileType = 'photo'
      try {
        this.selectedFileUrl = await this.$_getPicture({
          destinationType: Camera.DestinationType.FILE_URI,
          sourceType: sourceType,
          quality: 50,
          correctOrientation: true
        })
        this.isActivePreview = true
      } catch (err) {
        console.error(err)
      }
    },

    getPictureWithWeb(files: File[]) {
      this.file = Array.isArray(files) ? files[0] : files
      this.selectedFileUrl = URL.createObjectURL(this.file)
      this.selectedFileType = 'photo'
      this.isActivePreview = true
    },

    /**
     * Native の動画を取得
     */
    async getVideoWithNative(sourceType: number) {
      if (!this.$_hasCordova) {
        return
      }
      this.isLoading = true
      this.selectedFileType = 'video'

      try {
        let originalVideoWidth = null
        let originalVideoHeight = null
        if (sourceType === Camera.PictureSourceType.CAMERA) {
          const mediaFile: MediaFile = await this.$_caputureVideo()
          const mediaFileData = await this.$_getCaptureVideoMediaFileData(mediaFile)
          originalVideoWidth = mediaFileData.width
          originalVideoHeight = mediaFileData.height
          this.selectedFileUrl = mediaFile.fullPath
        } else {
          const options: CameraOptions = {
            destinationType: Camera.DestinationType.FILE_URI,
            mediaType: Camera.MediaType.VIDEO,
            quality: 50,
            sourceType: sourceType,
            correctOrientation: true
          }
          this.selectedFileUrl = await this.$_getPicture(options)
          let video: HTMLVideoElement = await loadmetadataVideo(this.selectedFileUrl)
          originalVideoWidth = video.videoWidth
          originalVideoHeight = video.videoHeight
          video = null
        }

        if (
          this.$_platformIsAndroid &&
          !new RegExp(location.protocol + '//').test(this.selectedFileUrl)
        ) {
          this.selectedFileUrl = location.protocol + '//' + this.selectedFileUrl
        }

        // オリジナルファイルが 1080 を超えているときだけ圧縮
        const shouldCompression = originalVideoWidth >= 1080 || originalVideoHeight >= 1080
        if (shouldCompression) {
          const transcodeVideoOptions = {
            fileUri: this.selectedFileUrl,
            outputFileName: generateUUID(),
            outputFileType: VideoEditorOptions.OutputFileType.MPEG4,
            optimizeForNetworkUse: VideoEditorOptions.OptimizeForNetworkUse.NO,
            saveToLibrary: false,
            deleteInputFile: false,
            maintainAspectRatio: true,
            width: originalVideoWidth * 0.5,
            height: originalVideoHeight * 0.5,
            videoBitrate: 1397000,
            fps: 30,
            audioChannels: 2,
            audioSampleRate: 48000,
            audioBitrate: 64000,
            progress: value => {
              if (value >= 100) {
                this.isLoading = false
              }
            }
          }
          this.selectedFileUrl = await this.$_transcodeVideo(transcodeVideoOptions)
        }
        this.isActivePreview = true
      } catch (err) {
        console.error(err)
        // 選択しなかった場合は何もしない
        if (
          err === 'No Image Selected' ||
          err === 'has no access to assets' ||
          (err.code && err.code === 3)
        ) {
          return
        }
        this.$_alert('動画圧縮失敗')
      } finally {
        this.isLoading = false
      }
    },

    getVideoWithWeb(files: File[]) {
      this.file = Array.isArray(files) ? files[0] : files
      this.selectedFileUrl = URL.createObjectURL(this.file)
      this.selectedFileType = 'video'
      this.isActivePreview = true
    },

    clearMediaFile() {
      if (this.isPhotoFileType) {
        this.imageFiles = []
      } else if (this.isVideoFileType) {
        this.videoFiles = []
      }
      this.file = null
      URL.revokeObjectURL(this.selectedFileUrl)
      this.selectedFileUrl = null
      this.selectedFileType = ''
      this.isActivePreview = false
      // ファイルの選択が解除されたらプレミアフラグも解除
      this.isPremier = false
    },

    /**
     * データをクリア
     */
    clearData() {
      this.body = ''
      if (this.selectedFileUrl) {
        this.clearMediaFile()
      }
      this.selectedFileType = ''
      this.isPremier = false
    },

    /**
     * 投稿する
     */
    async submit() {
      if (this.$_hasCordova && this.selectedFileUrl && this.reuseFlag !== '1') {
        this.submitWithNative()
        return
      }

      this.isSubmitting = true

      const fd = new FormData()
      fd.append('page', 'post')
      fd.append('body', this.body)
      fd.append('is_premier', this.isPremier + '')
      if (this.isRejected) {
        fd.append('reuse', this.reuseFlag)
        fd.append('t_id', this.rejectedEntry.t_id)
      }
      if (this.file) {
        fd.append('up_file', this.file)
        fd.append('up_file_type', this.selectedFileType)
      }

      try {
        const config = this.file ? { onUploadProgress: this.onUploadProgress } : {}
        const data = await this.post({ formData: fd, config: config })
        const error = data.error
        if (error) {
          this.errorSubmit(error)
          return
        }

        this.successSubmit()
        this.$store.commit('Timeline/setRejectedEntry', null)
      } catch (err) {
        this.failureSubmit(err)
      } finally {
        this.progressValue = 0
        this.isSubmitting = false
      }
    },

    /**
     * Native 機能で submit
     */
    async submitWithNative() {
      // Android のスクリーンショットの場合末尾にクエリパラメータがついていることがあるので削除しておく
      const fileName = this.selectedFileUrl
        .substr(this.selectedFileUrl.lastIndexOf('/') + 1)
        .split('?')[0]

      this.isSubmitting = true
      const params = {
        page: 'post',
        body: this.body,
        is_premier: this.isPremier + '', // 文字列にしないと数値として送信されてしまう
        up_file_type: this.selectedFileType
      }
      if (this.isRejected) {
        params['reuse'] = this.reuseFlag
        params['t_id'] = this.rejectedEntry.t_id
      }

      try {
        const mimeType = await this.$_nativePathToFileType(this.selectedFileUrl)
        const fileUploadOptions: FileUploadOptions = {
          chunkedMode: false,
          fileKey: 'up_file',
          fileName: fileName,
          mimeType: mimeType,
          headers: {
            TOKEN: this.$http.defaults.headers.common['TOKEN']
          },
          params: params
        }

        const res = await this.$_uploadFileTransfer(
          this.selectedFileUrl,
          this.$http.defaults.baseURL + '/timeline/',
          fileUploadOptions,
          this.onUploadProgress
        )

        const error = res.data.error
        if (error) {
          this.errorSubmit(error)
          return
        }
        this.successSubmit()
      } catch (err) {
        this.failureSubmit(err)
      } finally {
        this.progressValue = 0
        this.isSubmitting = false
      }
    },

    errorSubmit(error) {
      if (error.code) {
        if (error.code === 9) {
          this.$_showPointBuyDialog(error.description, error.message)
        } else if (error.code === 20) {
          this.$_ageAuth(error)
        }
      } else if (error.description && error.message) {
        this.$_alert(error.description, error.message)
      } else if (typeof error === 'string') {
        this.$_alert(error)
      }
      this.isSubmitting = false
    },

    successSubmit() {
      this.$_alert('投稿しました')
      this.setType(3)
      this.$router.replace('/timeline')
    },

    failureSubmit(err: Error) {
      this.progressValue = 0
      this.isSubmitting = false
      this.$_alert('ファイル送信失敗')
      console.error(err)
    },

    /**
     * Progress event handler
     */
    onUploadProgress(progressEvent: ProgressEvent) {
      const { loaded, total } = progressEvent
      this.progressValue = (loaded / total) * 100
    },

    /**
     * 削除ボタンクリック
     */
    handleRemoveClick() {
      const message =
        '審査で非公開となったこの投稿を削除してもポイントは返還されませんが、削除してよろしいですか？'
      this.$_handleTweetRemove(this.rejectedEntry.t_id, this.rejectedEntry.index, message)
    }
  }
})
